/* eslint-disable*/
import React from "react";
import ContractManagement_FlexMktPrint from "./FlexMktPrint";
import { screen, cleanup } from "@testing-library/react";
import "regenerator-runtime/runtime";
import userEvent from "@testing-library/user-event";
import { act } from "react-dom/test-utils";
import axios from "axios";
import renderTestScreen from "../../../../common/renderTestScreen";
import { t } from "../../../../__mocks__/react-i18next";

describe("FlexMktPrint Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<ContractManagement_FlexMktPrint />);
    });
  });
  afterEach(cleanup);
  test("is FlexMktPrint Loads Successfully", () => {
    expect(screen.getByText("FlexMktPrint")).toBeInTheDocument;
  });
  test("Custom Test Cases for FlexMktPrint", () => {
    // START_USER_CODE-USER_FlexMktPrint_Custom_Test_Case
    // END_USER_CODE-USER_FlexMktPrint_Custom_Test_Case
  });
});
describe("Widget Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<ContractManagement_FlexMktPrint />);
    });
  });
  afterEach(cleanup);
  test("groupboxwidget0(GroupBox Widget) Test Cases", async () => {
    const groupboxwidget0 = screen.getByTestId("groupboxwidget0");
    expect(groupboxwidget0.tagName).toBe("BUTTON");
    expect(groupboxwidget0.type).toBe("button");
    expect(groupboxwidget0.classList).toContain("btn");
    expect(groupboxwidget0.textContent).toEqual(
      t("ContractManagement:FlexMktPrint_groupboxwidget0")
    );
  });
  test("Custom Test Cases for groupboxwidget0", () => {
    // START_USER_CODE-USER_groupboxwidget0_TEST
    // END_USER_CODE-USER_groupboxwidget0_TEST
  });
});
